<template>
  <v-container style="width: 100vw !important">
    <custom-heading :breadcrumbs="breadcrumbs"/>

    <v-container fluid>
      <v-card-title class="pa-0">{{ student.first_name }} {{ student.last_name }}</v-card-title>
      <v-row
      >
        <v-col cols="12" md="9">
          <v-tabs
              v-model="selected"
              v-if="showTabs"
              centered
              style="border-bottom: thin solid rgba(0, 0, 0, 0.12);"
          >
            <v-tab
                v-for="(link, index) in navLinks"
                :key="link.title + '_' + index"
                @click="selected = index"
                style="min-width: 192px;"
            >{{ link.title }}
            </v-tab
            >
          </v-tabs>
        </v-col>
        <v-col cols="6" md="3">
          <div class="mb-4 float-center" v-if="$checkPermission('school_directory index')">
            <v-btn :to="`${previousId}`" color="primary">
              <v-tooltip color="primary" bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs"
                  >mdi-arrow-left
                  </v-icon
                  >
                </template
                >
                Prethodni učenik
              </v-tooltip
              >
            </v-btn>
            <v-btn :to="`${nextId}`" color="primary">
              <v-tooltip color="primary" bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs"
                  >mdi-arrow-right
                  </v-icon
                  >
                </template
                >
                Sljedeći učenik
              </v-tooltip
              >
            </v-btn>
          </div>
        </v-col>
      </v-row
      >
    </v-container>

    <div v-if="showTabs">
      <v-tabs-items v-model="selected">
        <v-tab-item v-for="item in navLinks" :key="item.title">
          <component
              v-bind:is="item.content"
              :department="department"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <ResetPassword/>
  </v-container>
</template>

<script>
import CustomHeading from "@/components/heading/CustomHeading";
import ApiV2 from "@/services/ApiV2";
import StudentInfo from "@/components/student/studentInfo/StudentInfo";
import StudentGradesTableView from "./StudentGradesTableView";
import StudentGraduation from "./StudentGraduation";
import StudentTestimonial from "./StudentTestimonial";
import StudentTestimonialChangeOfSchool from "./StudentTestimonialChangeOfSchool";
import StudentFinalExam from "@/components/department/departmentInfo/studentDetails/StudentFinalExam";
import ResetPassword from "@/components/dialogs/ResetPassword.vue";

export default {
  components: {
    ResetPassword,
    StudentFinalExam,
    CustomHeading,
    StudentInfo,
    StudentGradesTableView,
    StudentGraduation,
    StudentTestimonial,
    StudentTestimonialChangeOfSchool

  },
  created() {
    const studentId = this.$route.params?.ucenik_id;
    const departmentId = this.$route.params?.odjeljenje_id;

    this.selected = this.$route.query ? +this.$route.query.tab : 0;

    this.$store
        .dispatch("setEnrolledStudent", {
          departmentId: this.$route.params.odjeljenje_id,
          studentId: this.$route.params.ucenik_id,
        })
        .then(() => {
          this.getNeighbors();
        });

    this.$axios.post("ucenik/" + `${studentId}`).then((response) => {
      this.student = response.data;
      this.breadcrumbs.push({
        text: response.data.first_name + " " + response.data.last_name,
      });
    });

    ApiV2.get(`departments/${departmentId}`)
        .then((response) => {
          localStorage.setItem(
              "are_numerical_grades",
              response.data.are_numerical_grades
          );
          this.department = response.data
          this.graduationType = parseInt(response.data.graduation_type)
          this.breadcrumbs.push({text: response.data.label, href: `/admin/odjeljenje/pregled/${departmentId}`});
        })
        .finally(() => {
          this.showTabs = true;
        });
  },
  computed: {
    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },
    previousId() {
      return this.previous?.user_id;
    },
    nextId() {
      return this.next?.user_id;
    },
    navLinks() {
      let links = [
        {title: "osnovni podaci", content: 'StudentInfo', permission: 'for everyone'},
        {title: "predmeti i ocjene", content: 'StudentGradesTableView', permission: 'tab_diplomas_grades_in_department_student'},
        {title: "svjedodžba", content: 'StudentTestimonial', permission: 'tab_diplomas_in_department_student'}
      ]
      if (this.$route.params?.ucenik_id)
        links.splice(3, 0, {
          title: 'prijevodnica',
          content: 'StudentTestimonialChangeOfSchool',
          permission: 'change_of_school testimonial'
        })
      if (this.graduationType === 1) {
        links.splice(2, 0, {title: 'matura', content: 'StudentGraduation', permission: 'for everyone'})
      } else if (this.graduationType === 2) {
        links.splice(2, 0, {title: 'završni rad', content: 'StudentFinalExam', permission: 'for everyone'})
      }
      return links.filter(link => this.$checkPermission(link.permission))
    },


  },
  data() {
    return {
      student: {},
      next: null,
      department: null,
      previous: null,
      showTabs: false,
      graduationType: null,
      breadcrumbs: [
        {text: "Administracija"},
        {text: "E-matica"},
        {text: "Odjeli", disabled: false, href: "/admin/odjeljenje"},
      ],
      selected: 0
    };
  },

  methods: {
    async getNeighbors() {
      let {data} = await ApiV2.get(
          `department_enrollment/${this.enrolledStudent?.id}/previous_and_next_student`
      );
      this.previous = data.previous;
      this.next = data.next;
    },
  },
};
</script>
